import L from "leaflet";

L.WaterLevelIcon = L.DivIcon.extend({
  createIcon: function() {
    var div = document.createElement("div");
    div.className = 'marker';
    div.style.position = 'absolute';
    div.style.backgroundColor  = this.options.color;
    div.style.display = 'block';
    div.style.width = "35px";
    div.style.height = "35px";
    div.style.padding = "2px";
    div.style.border = "none";
    div.style.borderRadius = "15px";

    var img = document.createElement('img');
    img.src = "/img/flood.png"
    img.width = "25";
    img.height = "25";
    img.style.marginLeft = "3px";
    img.style.marginTop = "8px";
    div.appendChild(img);

    this.options.className = "air-div-icon";
    this.iconSize = [35, 35];

    this.dom = div;
    this._setIconStyles(this.dom, 'div');

    return this.dom;
  }
});

L.waterLevelIcon = function(options) {
  return new L.WaterLevelIcon(options);
};